import React, { FC, useState } from 'react'

import { Filter, RelativeDateFilter } from '../types'
import { ConditionOperatorType } from '../enums'
import { Input, Select, Space } from 'antd'

type RelativeDateFilterValueBuilderProps = {
    filter: RelativeDateFilter
    onChange: (value: Filter) => void
}

export const RelativeDateFilterValueBuilder: FC<RelativeDateFilterValueBuilderProps> = ({ filter, onChange }) => {
    const [relativeDateOperator, setRelativeDateOperator] = useState<
        ConditionOperatorType.LTE | ConditionOperatorType.GT
    >(filter.value.operator)

    return (
        <Space.Compact size="middle" block>
            <Select<ConditionOperatorType.LTE | ConditionOperatorType.GT>
                size="middle"
                options={[
                    { value: ConditionOperatorType.LTE, label: 'is within' },
                    { value: ConditionOperatorType.GT, label: 'is not within' },
                ]}
                onChange={(operator) => {
                    setRelativeDateOperator(operator)

                    onChange({
                        ...filter,
                        value: {
                            operator,
                            value: filter.value[filter.value.operator],
                            meta: filter.value.meta ?? {},
                        },
                    })
                }}
                value={relativeDateOperator}
            />
            <Input
                className="date-filter-relative-date-input"
                size="middle"
                value={filter.value.value}
                onChange={(ev) => {
                    const value = ev.target.value
                    if (!ev.target.value) {
                        return
                    }

                    onChange({
                        ...filter,
                        value: {
                            ...filter.value,
                            value: parseInt(value, 10),
                        },
                    })
                }}
                type="number"
            />
            <Select<'days' | 'weeks' | 'months'>
                className="date-filter-relative-date-qualifier-select"
                size="middle"
                value={filter.value.meta.qualifier}
                onChange={(v) => {
                    onChange({
                        ...filter,
                        value: {
                            ...filter.value,
                            meta: {
                                ...filter.value.meta,
                                qualifier: v,
                            },
                        },
                    })
                }}
                options={[
                    { value: 'hours', label: 'hours' },
                    { value: 'days', label: 'days' },
                    { value: 'weeks', label: 'weeks' },
                    { value: 'months', label: 'months' },
                ]}
            />
        </Space.Compact>
    )
}
